<template>
  <v-container fluid grid-list-md>
    <v-layout align-center justify-center row>
      <v-flex xs12>
        <v-card>
          <card-toolbar title="Detay"></card-toolbar>
          <v-data-table :headers="headers" :items="items" hide-default-footer>
          </v-data-table>
          <v-pagination
            v-model="pagination.page"
            :length="pagination.last_page"
          ></v-pagination>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import CardToolbar from "../../Components/CardToolbar.vue";
export default {
  components: {
    CardToolbar,
  },
  data: () => ({
    pagination: {
      page: 1,
      last_page: null,
      total: null,
    },
    items: [],
    headers: [
      {
        text: "Telefon",
        align: "start",
        sortable: false,
        value: "phone",
      },
      {
        text: "Mesaj",
        align: "start",
        sortable: false,
        value: "message",
      },
      {
        text: "Tarih",
        align: "start",
        sortable: false,
        value: "created_at",
      },
    ],
  }),
  methods: {
    ...mapActions({ send: "sendBackend" }),
    getData(page = 1) {
      this.send({
        route: `iys/blocked/list/${this.$route.params.id}?page=${page}`,
      }).then((response) => {
        this.pagination = {
          ...this.pagination,
          last_page: response.data.data.last_page,
          total: response.data.data.total,
        };
        this.items = [...response.data.data.data];
      });
    },
  },
  created() {
    this.getData();
  },
  watch: {
    "pagination.page"(val) {
      this.getData(val);
    },
  },
};
</script>